import React from "react";
import { CheckIcon } from "../../Assets/Icons";

const VerifyAnimationModal = ({ message }) => {
  return (
    <>
      <div className="assignsuccess p-4">
        <CheckIcon />
        <h6>{message}</h6>
      </div>
    </>
  );
};

export default VerifyAnimationModal;
